<template>
  <div>
    <div id="container-table">
      <table class="table table-hover ui-table">
        <thead>
          <tr>
            <th>{{ $t('school.payment.setup.feeSetup.name') }}</th>
            <th style="width: 10%" class="text-center">
              {{ $t('school.payment.setup.feeSetup.quantity') }}
            </th>
            <th style="width: 10%" class="text-center">
              {{ $t('school.payment.setup.feeSetup.uom') }}
            </th>
            <th style="width: 10%" class="text-center">
              {{ $t('school.payment.setup.feeSetup.price') }}
            </th>
            <th style="width: 3%" class="text-center">
              <a href="#" @click.prevent="addNewRow" v-if="!product_fetch">
                <i class="fa fa-plus"></i>
              </a>
              <a href="#" v-else>
                <i class="fa fa-spinner spin"></i>
              </a>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(sub, index) in model.sub_item_list" :key="index">
            <td>
              <!-- <ts-search-select
                v-model.number="sub.product_id"
                @change="setValueUom(sub)"
                :options="
                  productListExcludeSelectedProduct({
                    addedProducts: model.sub_item_list,
                    excludeProduct: sub.product_id
                  }).map(el => ({
                    text: el.product_name_en,
                    value: el.product_id
                  }))
                "
              ></ts-search-select> -->

              <a-select
                v-model.number="sub.product_id"
                style="width:100%"
                :showSearch="true"
                :options="
                  productListExcludeSelectedProduct({
                    addedProducts: model.sub_item_list,
                    excludeProduct: sub.product_id
                  }).map(el => ({
                    label: el.product_name_en,
                    value: el.product_id
                  }))
                "
                :filterOption="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                "
                @change="setValueUom(sub)"
              />

              <!-- <select
                v-model="sub.product_id"
                @change="setValueUom(sub)"
                class="form-control only-bottom-border"
                :class="{'is-invalid': errors.has('sub_item_list.'+ index + '.product_id')}"
              >
                <option value>{{$t('select')}}</option>
                <option
                  v-for="(product, index) in productListExcludeSelectedProduct({addedProducts: model.sub_item_list,excludeProduct:sub.product_id })"
                  :key="index"
                  :value="product.product_id"
                >{{product.product_name_en}}</option>
              </select> -->
              <div
                class="validate"
                v-if="errors.has('sub_item_list.' + index + '.product_id')"
              >
                {{ errors.first('sub_item_list.' + index + '.product_id') }}
              </div>
            </td>
            <td class="text-center">
              <input
                v-model.number="sub.quantity"
                class="form-control only-bottom-border text-center"
                :class="{
                  'is-invalid': errors.has(
                    'sub_item_list.' + index + '.quantity'
                  )
                }"
                type="number"
                @input="calulateFeeAmount"
              />
              <div
                class="invalid-feedback"
                v-if="errors.has('sub_item_list.' + index + '.quantity')"
              >
                {{ errors.first('sub_item_list.' + index + '.quantity') }}
              </div>
            </td>
            <td class="text-center">
              <input
                :value="getUom(sub.product_id).uom_name_en"
                class="form-control only-bottom-border text-center"
                :class="{
                  'is-invalid': errors.has('sub_item_list.' + index + '.uom_id')
                }"
                type="text"
                readonly
              />
              <div
                class="invalid-feedback"
                v-if="errors.has('sub_item_list.' + index + '.uom_id')"
              >
                {{ errors.first('sub_item_list.' + index + '.uom_id') }}
              </div>
            </td>
            <td>
              <input
                disabled
                type="number"
                :value="productPrice(sub.product_id, sub.uom_id).sale_price"
                step="any"
                class="form-control only-border-bottom text-center"
              />
            </td>
            <td class="text-center" valign="middle">
              <a href="#" class="text-danger" @click.prevent="removeRow(sub)">
                <i class="fa fa-trash mt-2"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { Errors } from 'form-backend-validation'
import _ from 'lodash'

export default {
  name: 'subItems',
  props: ['value', 'validate'],
  data() {
    return {
      model: {},
      newRow: {
        fee_setup_item_id: 0,
        product_id: '',
        quantity: 1,
        uom_id: '',
        sale_price: 0
      },
      product_fetch: true,
      errors: new Errors()
    }
  },
  created() {
    this.model = this.value
    this.setEditData()
  },
  computed: {
    ...mapState('feeSetup', ['products', 'edit_data']),
    ...mapGetters('feeSetup', [
      'productListExcludeSelectedProduct',
      'getUom',
      'productPrice'
    ])
  },
  methods: {
    ...mapActions('feeSetup', ['getProduct']),
    addNewRow() {
      this.model.sub_item_list.push(Object.assign({}, this.newRow))
    },
    removeRow(record) {
      this.model.sub_item_list.splice(
        this.model.sub_item_list.indexOf(record),
        1
      )
    },
    setValueUom(product) {
      product.uom_id = this.getUom(product.product_id).uom_id
      try {
        let productPrice = this.productPrice(product.product_id, product.uom_id)
        productPrice
          ? (product.sale_price = _.ceil(productPrice.sale_price, 2))
          : (product.sale_price = 0)
      } catch (e) {
        product.sale_price = ''
      }
      this.calulateFeeAmount()
    },
    calulateFeeAmount() {
      if (_.isEmpty(this.edit_data)) {
        this.model.fee_amount = _.sumBy(this.model.sub_item_list, o => {
          return (
            o.quantity * this.productPrice(o.product_id, o.uom_id).sale_price
          )
        })
      }
    },
    async setEditData() {
      await this.getProduct()
      this.product_fetch = false
      if (!_.isEmpty(this.edit_data)) {
        this.model.sub_item_list = []
        this.edit_data.fee_sub_items.map(e => {
          this.model.sub_item_list.push({
            fee_setup_item_id: e.fee_sub_item_id,
            product_id: e.product_id,
            quantity: e.quantity,
            uom_id: e.uom_id
          })
        })
      }
    }
  },
  watch: {
    'model.sub_item_list': {
      handler() {
        this.calulateFeeAmount()
      },
      deep: true
    },
    validate: {
      handler() {
        this.errors = new Errors(this.validate.errors)
      },
      deep: true
    }
  }
}
</script>

<style lang="css" scoped>
#container-table {
  max-height: 30vh;
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
::-webkit-scrollbar {
  width: 3px; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}
/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  background: rgb(194, 194, 194);
}
.table > thead > tr > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 999;
}
.table > tbody > tr > td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border: none !important;
}
.only-bottom-border {
  border-top: none;
  border-left: none;
  border-right: none;
}
</style>
